export default __webpack_public_path__ + "static/media/Ônibus.93e9cef1.svg";